module.exports = __webpack_public_path__ + "static/media/Ideas.1ba1d369.md";